import { useState } from 'react';

import {
  AssignmentQueue,
  useAssignToQueue,
} from '../api/middle-office/assignmentQueue';
import { handleError, handleSuccess } from '../utils/admin';
import {
  useSubscribeToListDocumentQueueAssigned,
  useSubscribeToListNoDocumentsToAssign,
} from '../websocketApi/list';
import { useEventHandler } from './useEventHandler';

export const useApplicationQueueEvents = () => {
  const { assignToQueue } = useAssignToQueue();
  const [assigning, setAssigning] = useState(false);

  useSubscribeToListDocumentQueueAssigned(({ message }) => {
    setAssigning(false);
    handleSuccess(message, 'Success');
  });

  useSubscribeToListNoDocumentsToAssign(({ message }) => {
    setAssigning(false);
    handleError(message);
  });

  const assignApplication = useEventHandler(
    async (documentType: string, queue: AssignmentQueue) => {
      try {
        setAssigning(true);
        await assignToQueue({
          documentDefinition: documentType,
          queueId: queue.id,
        });
      } catch (error: any) {
        setAssigning(false);
        handleError('Failed to assign application. Please try again.');
      }
    },
  );

  return { assigning, assignApplication };
};
